"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "A+ Fire provided exceptional service. Mike responded immediately to our emergency call and had our kitchen suppression system back up and running within hours. Highly professional!",
  clientName: "Sarah Mitchell",
  clientPhoto: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/client_sarah_mitchell.png"
}, {
  id: 2,
  quote: "Finally found a fire safety company that doesn't try to upsell unnecessary services. Mike is honest, knowledgeable, and always available when you need him.",
  clientName: "James Rodriguez",
  clientPhoto: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/client_james_rodriguez.png"
}, {
  id: 3,
  quote: "We've been using A+ Fire for annual inspections across all our restaurant locations. Mike's attention to detail and direct communication makes everything so much easier.",
  clientName: "Emily Chen",
  clientPhoto: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/client_emily_chen.png"
}, {
  id: 4,
  quote: "Fast, reliable, and fair pricing. Mike came out the same day to recharge our extinguishers and provided a full walkthrough of our fire safety needs. Won't call anyone else!",
  clientName: "Michael Thompson",
  clientPhoto: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/client_michael_thompson.png"
}, {
  id: 5,
  quote: "A+ Fire has been maintaining our commercial kitchen systems for two years now. Mike's proactive approach has helped us stay compliant and safe. Excellent service!",
  clientName: "Lisa Patel",
  clientPhoto: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/client_lisa_patel.png"
}, {
  id: 6,
  quote: "When our sprinkler system failed inspection, Mike not only fixed it but educated us on proper maintenance. Family-owned service you can trust!",
  clientName: "David Brown",
  clientPhoto: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1470228/img/client_david_brown.png"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [api, setApi] = React.useState<any>();
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    if (!api) return;
    const intervalId = setInterval(() => {
      if (!isHovered && api.canScrollNext()) {
        api.scrollNext();
      } else if (!isHovered && !api.canScrollNext()) {
        api.scrollTo(0);
      }
    }, 4000);
    return () => clearInterval(intervalId);
  }, [api, isHovered]);
  return <section ref={ref} className={`w-full bg-light-background py-16 px-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold font-display text-foreground-light mb-3">
            What Our Clients Say
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Don't just take our word for it — hear from businesses and
            homeowners across Northern Virginia who trust A+ Fire for their
            fire protection needs.
          </p>
        </div>

        <div className="relative px-12">
          <Carousel setApi={setApi} opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <Card className="h-full shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1">
                    <CardContent className="flex flex-col items-start gap-4 p-6">
                      <Quote className="text-primary w-10 h-10 mb-2" />
                      <p className="text-foreground-light text-base leading-relaxed flex-grow">
                        "{testimonial.quote}"
                      </p>
                      <div className="flex items-center gap-3 mt-4 pt-4 border-t border-border w-full">
                        <SafeHydrate><Avatar className="w-12 h-12 border-2 border-primary/20">
                          <AvatarImage src={testimonial.clientPhoto} alt={testimonial.clientName} />
                          <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                            {testimonial.clientName.split(" ").map(n => n[0]).join("")}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>
                        <div>
                          <p className="font-semibold text-foreground-light">
                            {testimonial.clientName}
                          </p>
                          <p className="text-sm text-muted-foreground">
                            Verified Client
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>

            <CarouselPrevious className="absolute -left-4 top-1/2 -translate-y-1/2 bg-light-background border-border hover:bg-primary hover:text-foreground-primary hover:border-primary shadow-soft transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)]" />
            <CarouselNext className="absolute -right-4 top-1/2 -translate-y-1/2 bg-light-background border-border hover:bg-primary hover:text-foreground-primary hover:border-primary shadow-soft transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)]" />
          </Carousel>
        </div>
      </div>
    </section>;
}